<template>
  <div class="container">
    <van-image class="logo" :src="require('@/assets/images/puhui/logo.png')" fit="contain" />

    <div class="search-wrapper">
      <van-icon size="8vw" :name="require('@/assets/svg/scan.svg')" @click="qrScan" />

      <div class="search__content" @click="$router.push('/store-list')">
        <van-icon size="4.8vw" :name="require('@/assets/svg/search.svg')" />
        <span>特产土货</span>
      </div>

      <div><van-icon :name="require('@/assets/svg/location.svg')" /> 玉林</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  methods: {
    /**
     * 扫一扫
     */
    qrScan() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'QRScanMethod', '')
        this.$callApp('iOS', 'QRScanMethod', '')
      } else {
        this.$dialog.alert({
          title: '此功能需要访问客户端才能使用',
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: #fff;

  .logo {
    height: 44px;
    margin: 0 15px;
    display: block;
    position: relative;

    /deep/ img {
      width: auto;
    }

    &::after {
      content: ' ';
      position: absolute;
      left: -20px;
      right: -20px;
      bottom: 0;
      height: 1px;
      background-color: #e4e5e5;
    }
  }

  .search {
    &-wrapper {
      height: 40px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 4px 12px;
      font-size: 14px;
    }

    &__content {
      display: flex;
      flex: 1;
      align-items: center;
      margin: 0 10px;
      padding: 6px 10px;
      color: #9fa0a0;
      font-size: 12px;
      border-radius: 25px;
      border: 1px solid #b1b1b1;

      & > *:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
</style>
